import React from 'react';
import {
  Box,
  FormControl,
  Select,
  MenuItem,
  Typography,
} from '@mui/material';
import { FormField, FormFieldOption } from '../../types';

interface SelectFieldInputProps {
  field: FormField;
  options: FormFieldOption[];
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

export const SelectFieldInput: React.FC<SelectFieldInputProps> = ({
  field,
  options,
  onChange,
}) => {
  const inputName = field.id === 'firstName' || field.id === 'lastName' ? field.id : field.name;

  return (
    <Box sx={{ mb: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 1 }}>
        <Typography
          component="label"
          htmlFor={inputName}
          sx={{ fontWeight: 500, color: '#000000' }}
        >
          {field.label || field.name}
        </Typography>
        {field.required && (
          <Typography sx={{ color: '#dc5456', fontWeight: 'bold' }}>*</Typography>
        )}
      </Box>
      <FormControl fullWidth size="small" variant="outlined">
        <Select
          id={inputName}
          name={inputName}
          defaultValue=""
          onChange={(e) => onChange(e as any)}
          required={field.required}
        >
          <MenuItem disabled value="">
            -- Select an option --
          </MenuItem>
          {options.map((option, idx) => (
            <MenuItem key={idx} value={option.value || option.option || ''}>
              {option.label || option.option}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default SelectFieldInput;
